import React, { useEffect, useState } from "react";
import Header from "../common/Header";
import $ from "jquery";
import { Link } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { dateFormat } from "../helpers/date";
import OnHandPreviewModal from "../../modal/OnHandPreviewModal";
import Toastify from "../common/Toastify";
import { GETREQUEST, POSTREQUEST } from "../helpers/ServiceRequest";

function OnHandOrder() {
  const { user } = useAuth();
  const [orderDate, setOrderDate] = useState(dateFormat);
  const [showPreviewOrder, setShowPreviewOrder] = useState(false);
  const [orderDetailsObj, setOrderDetailsObj] = useState({});
  const [orderDetails, setOrderDetails] = useState([]);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [productId, setProductId] = useState(null);

  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");
  });

  useEffect(() => {
    const fetchData = async () => {
      let URL = process.env.REACT_APP_API_URL + `/on-hand-orders?orderDate=${orderDate}`;
      let response = await GETREQUEST(URL, user.jwtToken);
      let orderData = response?.data
      if (orderData?.length > 0) {
        const orderObjArray = {};
        const productSet = new Set();
        const sortedProducts = [];

        orderData.forEach(item => {
          const { ProductID } = item;

          if (!orderObjArray[ProductID]) {
            orderObjArray[ProductID] = [];
          }
          orderObjArray[ProductID].push(item);

          if (!productSet.has(ProductID)) {
            sortedProducts.push(item);
            productSet.add(ProductID);
          }
        });

        // Sort each group by BuyerCode
        Object.values(orderObjArray).forEach(orderItem => {
          orderItem.sort((a, b) => {
            const codeA = a.tblOrder.tblCustomer.BuyerCode?.toUpperCase() || '';
            const codeB = b.tblOrder.tblCustomer.BuyerCode?.toUpperCase() || '';
            return codeA.localeCompare(codeB);
          });
        });

        // Sort products by ProductName
        sortedProducts.sort((a, b) => (a.ProductName || '').localeCompare(b.ProductName || ''));

        setOrderDetails(sortedProducts);
        setOrderDetailsObj(orderObjArray);
      }
    }
    fetchData();

  }, [orderDate])

  const saveBulkOrder = async (bulkOrderDetail) => {
    let buyingSheetURL = process.env.REACT_APP_API_URL + `/update-orders-details`;
    setMessage('');
    setMessageType('');
    setShowPreviewOrder(false);

    let response = await POSTREQUEST(buyingSheetURL, bulkOrderDetail, user.jwtToken);
    if (response.data) {
      setProductId(null);
      setMessage(response.data?.message);
      setMessageType('success');
    } else {
      setMessage(response?.error?.message);
      setMessageType('error');
    }
  }

  const updateOrderDetails = (orderDetails) => {
    const groupedOrders = {};
    const orderObjArray = {};

    Object.values(orderDetails).flat().forEach(orderItem => {
      const orderId = orderItem.OrderID;
      const excludedKeys = ['tblAgent', 'tblOrder', 'tblUnit'];
      const filteredObj = { ...orderItem };

      excludedKeys.forEach(key => {
        delete filteredObj[key];
      });

      if (!groupedOrders[orderId]) {
        groupedOrders[orderId] = {
          OrderID: orderItem.OrderID,
          ODID: orderItem.ODID,
          OrderDate: orderItem.tblOrder.OrderDate,
          PurchaseOrder: orderItem.tblOrder.PurchaseOrder,
          DeliveryInstructions: orderItem.tblOrder.DeliveryInstructions,
          OrderNotes: orderItem.tblOrder.OrderNotes,
          CustomerID: orderItem.tblOrder.CustomerID,
          AgentId: orderItem.tblAgent.AgentID,
          OrderDetails: []
        };
      }
      groupedOrders[orderId].OrderDetails.push({ ...filteredObj });

      if (orderObjArray[orderItem.ProductID]) {
        orderObjArray[orderItem.ProductID].push(orderItem)
      } else {
        orderObjArray[orderItem.ProductID] = [orderItem]
      }
    });

    const groupedValues = Object.values(groupedOrders);
    setOrderDetailsObj(orderObjArray);
    saveBulkOrder(groupedValues);
  }

  return (
    <React.Fragment>
      {showPreviewOrder && <OnHandPreviewModal modal={showPreviewOrder} orderDetailsObj={orderDetailsObj} productId={productId} updateOrderDetails={updateOrderDetails} setModal={setShowPreviewOrder} />}
      <Header />
      {message && <Toastify message={message} type={messageType} />}
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-3 pb-4 overflow-hidden table-listing">
          <div className="table-elements">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item fs-15">
                  <Link
                    to="/all-orders"
                    className="text-decoration-none text-primary"
                  >
                    Orders
                  </Link>
                </li>
                <li
                  className="breadcrumb-item fs-15 active"
                  aria-current="page"
                >
                  On Hand Order
                </li>
              </ol>
            </nav>
          </div>
          <div className="card border-bottom-0">
            <div className="card-header bg-white d-flex align-items-lg-center justify-content-between cpx-20 cpy-14 sticky-top flex-nowrap">
              <h1 className="title-semibold fs-24 mb-xl-0 mb-0 d-flex align-items-center text-nowrap me-5 me-xl-0">
                On Hand Order
              </h1>
              <div className="filter-elements d-flex align-items-center">
                <div className="custom-group flex-nowrap mb-lg-0">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Ship date:
                  </label>
                  <div className="position-relative" data-provide="datepicker">
                    <input
                      type="date"
                      id="datepicker"
                      className="form-control input-sm date input-datepicker"
                      placeholder="Select Date"
                      defaultValue={orderDate}
                      onChange={(e) => {
                        setOrderDate(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div></div>
            </div>
            <div className="card-body p-4 border-bottom">
              <div className="card-table table-responsive position-relative">
                <table className="table table-form mb-0">
                  <thead>
                    <tr>
                      <td scope="col" className="width-lg-1">Product Code</td>
                      {/* <td scope="col" className="width-lg-10">Buyer Code</td> */}
                      <td scope="col" className="width-lg-20 text-center">Product Name</td>
                      <td scope="col" className="width-lg-10 text-center">Class Name</td>
                      <td scope="col" className="width-lg-10 text-center">Size Name</td>
                      <td scope="col" className="width-lg-10 text-center">Unit Name</td>
                      {/* <td scope="col" className="width-lg-10">Qty</td> */}
                      <td scope="col" className="width-lg-10"></td>
                    </tr>
                  </thead>
                  <tbody>
                    {orderDetails?.map((orderDetailItem) => {
                      return (<tr key={orderDetailItem.ProductID} className="custom-space">
                        <td>
                          <input
                            type="text"
                            className="form-control input-sm input-width-100"
                            placeholder="Product Code"
                            value={orderDetailItem.ProductCode}
                            disabled
                          />
                        </td>
                        {/* <td>
                          <input
                            type="text"
                            className="form-control input-sm input-width-100"
                            placeholder="Product Name"
                            value={orderDetailItem.tblOrder.tblCustomer.BuyerCode}
                            disabled
                          />
                        </td> */}
                        <td>
                          <input
                            type="text"
                            className="form-control input-sm input-width-100"
                            placeholder="Product Name"
                            value={orderDetailItem.ProductName}
                            disabled
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control input-sm input-width-100"
                            placeholder="Class Name"
                            value={`${orderDetailItem.ClassName || ""}`}
                            disabled
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control input-sm input-width-100"
                            placeholder="Size Name"
                            value={`${orderDetailItem.SizeName || ""} `}
                            disabled
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control input-sm input-width-100"
                            placeholder="Unit"
                            value={orderDetailItem.tblUnit.UnitName}
                            disabled
                          />
                        </td>
                        {/* <td>
                          <input
                            type="text"
                            className="form-control input-sm input-width-100"
                            placeholder="Qty"
                            value={orderDetailItem.Qty}
                            onChange={(e) => updateQty(e.target.value, index)}
                          />
                        </td> */}

                        <td>
                          <button
                            type="button"
                            onClick={() => { setProductId(orderDetailItem.ProductID); setShowPreviewOrder(true) }}
                            className={`btn btn-outline-secondary btn-md d-flex align-items-center px-4 fw-medium rounded-3 mx-1`}
                          >
                            Preview
                          </button>
                        </td>
                      </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
              <div className="spacer-sm-5"></div>
              <div className="spacer-sm-5"></div>
              <div className="row">
                <div className="col d-flex flex-column justify-content-between align-items-end mt-4 mt-lg-0">

                  <div className="d-flex">
                    {/* <button
                      onClick={() => updateOrderDetails(orderDetails)}
                      className="btn btn-md btn-secondary d-flex align-items-center px-4 fw-medium text-white rounded-3 mx-1"
                    >
                      Save
                    </button> */}
                    <button type="button"
                      onClick={() => { navigate("/veg-art") }}
                      className="btn btn-md btn-secondary text-white d-flex align-items-center px-4 fw-medium rounded-3"
                    >
                      Exit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default OnHandOrder;
